/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Editemail_Bcc_Notice2Inputs */

const en_coinvestments_editemail_bcc_notice2 = /** @type {(inputs: Coinvestments_Editemail_Bcc_Notice2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opportunity owner will be BCC’d`)
};

/**
* | output |
* | --- |
* | "Opportunity owner will be BCC’d" |
*
* @param {Coinvestments_Editemail_Bcc_Notice2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_editemail_bcc_notice2 = /** @type {((inputs?: Coinvestments_Editemail_Bcc_Notice2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Editemail_Bcc_Notice2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_editemail_bcc_notice2(inputs)
});
export { coinvestments_editemail_bcc_notice2 as "coInvestments_editEmail_bcc_notice" }